import BigNumber from 'bignumber.js';
import _ from 'lodash';
import {
  FETCH_ALL_ORDER_BOOK,
  FETCH_ALL_ORDER_BOOK_SUCCEED,
  FETCH_ALL_ORDER_BOOK_FAILED,
  CLICK_ORDER_BOOK_BUY,
  CLICK_ORDER_BOOK_SELL, MAKE_ORDER_BOOK_EMPTY,
} from '../actions/orderbook/action_types';
import consts from '../../consts';
import utils from '../../common/utils';

export default (state = {
  totalOrderBook: 0,
  orderBooks: [],
  buyOrderBooks: [],
  sellOrderBooks: [],
  mapBuyOrderBooks: {},
  mapSellOrderBooks: {},
  isTableLoading: false,
  price: 0,
  buyQuantity: 0,
  buyTotal: 0,
  sellQuantity: 0,
  sellTotal: 0,
  maxQuantity: 0,
  isClickedOrderBookBuy: false,
  isClickedOrderBookSell: false,
}, action) => {
  const { params } = action;
  let quantity = 0;
  let maxQuantity;
  let isBuy;
  let fieldUpdate;
  let fieldUpdateLeft;
  let mapOrderBooks;
  let mapOrderBooksLeft;
  let orderBooks;
  let orderBooksLeft;
  let maxOrderBook;
  let maxOrderBookLeft;
  let prePrice;
  let maxPrice;
  let minPrice;
  let buyOrderBooks;
  let sellOrderBooks;
  let maxSellOrderBooks;
  let maxBuyOrderBooks;
  let mapBuyOrderBooks;
  let mapSellOrderBooks;

  switch (action.type) {
    case FETCH_ALL_ORDER_BOOK:
      return {
        ...state,
        isTableLoading: true,
        buyOrderBooks: [],
        sellOrderBooks: [],
        mapBuyOrderBooks: {},
        mapSellOrderBooks: {},
        maxQuantity: 0,
        isClickedOrderBookBuy: false,
        isClickedOrderBookSell: false,
      };
    case FETCH_ALL_ORDER_BOOK_SUCCEED:
      buyOrderBooks = [];
      sellOrderBooks = [];
      maxQuantity = 0;
      _.forEach(params.data, (order) => {
        order.total = utils.trimRightZeroAndDot(new BigNumber(order.price).times(order.quantity).toFixed(8));
        order.key = order.price;
        maxQuantity = Math.max(maxQuantity, order.quantity);

        if (order.trade_type === consts.ORDER_TRADE_TYPE_BUY) {
          const isLengthZero = buyOrderBooks.length === 0;
          order.cumulate = (isLengthZero) ? order.quantity : (_.last(buyOrderBooks).cumulate + order.quantity);
          order.sum = (isLengthZero) ? order.total
            : utils.trimRightZeroAndDot(new BigNumber(_.last(buyOrderBooks).sum).plus(order.total).toFixed(8));
          buyOrderBooks.push(order);
        } else {
          const isLengthZero = sellOrderBooks.length === 0;
          order.cumulate = (isLengthZero) ? order.quantity : (_.last(sellOrderBooks).cumulate + order.quantity);
          order.sum = (isLengthZero) ? order.total : utils.trimRightZeroAndDot(new BigNumber(_.last(sellOrderBooks).sum).plus(order.total).toFixed(8));
          sellOrderBooks.push(order);
        }
      });

      // add style
      _.forEach(buyOrderBooks, (order) => {
        order.style = {
          width: `${order.quantity / maxQuantity * 100}%`,
          backgroundColor: 'rgba(22,177,87,0.4)',
        };
      });
      _.forEach(sellOrderBooks, (order) => {
        order.style = {
          width: `${order.quantity / maxQuantity * 100}%`,
          backgroundColor: 'rgba(240,83,89,0.4)',
        };
      });

      return {
        ...state,
        maxQuantity,
        buyOrderBooks,
        sellOrderBooks,
        mapBuyOrderBooks: _.keyBy(buyOrderBooks, 'price'),
        mapSellOrderBooks: _.keyBy(sellOrderBooks, 'price'),
        isTableLoading: false,
        isClickedOrderBookBuy: false,
        isClickedOrderBookSell: false,
      };
    case FETCH_ALL_ORDER_BOOK_FAILED:
      return {
        ...state,
        isTableLoading: false,
        isClickedOrderBookBuy: false,
        isClickedOrderBookSell: false,
      };
    case CLICK_ORDER_BOOK_BUY:
      quantity = window._.get(action.params.data, 'cumulate', window._.get(action.params.data, 'quantity', 0));
      return {
        ...state,
        price: action.params.data.price,
        buyQuantity: quantity,
        buyTotal: parseFloat(utils.trimRightZero(new BigNumber(action.params.data.price).times(action.params.data.quantity).toFixed(8)) || 0),
        sellTotal: 0,
        sellQuantity: 0,
        isClickedOrderBookBuy: true,
        isClickedOrderBookSell: false,
      };
    case CLICK_ORDER_BOOK_SELL:
      quantity = window._.get(action.params.data, 'cumulate', window._.get(action.params.data, 'quantity', 0));
      return {
        ...state,
        price: action.params.data.price,
        sellQuantity: quantity,
        sellTotal: parseFloat(utils.trimRightZero(new BigNumber(action.params.data.price).times(quantity).toFixed(8)) || 0),
        buyTotal: 0,
        buyQuantity: 0,
        isClickedOrderBookBuy: false,
        isClickedOrderBookSell: true,
      };
    case consts.WS_EVENT_PUBLIC_ORDER_BOOK:
      maxQuantity = 0;
      isBuy = action.options.trade_type === consts.ORDER_TRADE_TYPE_BUY_STR;
      fieldUpdate = isBuy ? 'Buy' : 'Sell';
      fieldUpdateLeft = isBuy ? 'Sell' : 'Buy';
      mapOrderBooks = isBuy ? state.mapBuyOrderBooks : state.mapSellOrderBooks;
      mapOrderBooksLeft = isBuy ? state.mapSellOrderBooks : state.mapBuyOrderBooks;

      // re-calculate quantity, sum, cumulate

      if (action.data.quantity === 0) {
        delete mapOrderBooks[action.data.price];
      } else {
        mapOrderBooks[action.data.price] = action.data;
      }

      prePrice = 0;

      orderBooks = _.chain(mapOrderBooks).values().orderBy(['price'], isBuy ? 'desc' : 'asc').value();
      orderBooksLeft = _.chain(mapOrderBooksLeft).values().orderBy(['price'], isBuy ? 'asc' : 'desc').value();
      maxOrderBook = _.maxBy(orderBooks, 'quantity');
      maxOrderBookLeft = _.maxBy(orderBooksLeft, 'quantity');
      maxQuantity = Math.max(_.get(maxOrderBookLeft, 'quantity', 0), _.get(maxOrderBook, 'quantity', 0));

      _.forEach(orderBooks, (order) => {
        // add style
        order.total = new BigNumber(order.price).times(order.quantity).toFixedAndTrim(8);
        order.key = order.price;
        order.style = {
          width: `${`${order.quantity / maxQuantity * 100}`.substr(0, 4)}%`,
          backgroundColor: isBuy ? 'rgba(22,177,87,0.4)' : 'rgba(240,83,89,0.4)',
        };

        const [orderPrice, dataPrice] = isBuy ? [action.data.price, order.price] : [order.price, action.data.price];
        if (new BigNumber(orderPrice).minus(dataPrice).isPositive()) {
          const preCumulate = _.get(mapOrderBooks, [prePrice, 'cumulate'], 0);
          order.cumulate = new BigNumber(order.quantity).plus(new BigNumber(preCumulate)).toNumber();
          order.sum = new BigNumber(_.get(mapOrderBooks[prePrice], 'sum', 0)).plus(order.total).toFixedAndTrim(8);
        }

        prePrice = order.price;
      });

      prePrice = 0;
      _.forEach(orderBooksLeft, (order) => {
        // add style
        order.total = new BigNumber(order.price).times(order.quantity).toFixedAndTrim(8);
        order.key = order.price;
        order.style = {
          width: `${`${order.quantity / maxQuantity * 100}`.substr(0, 4)}%`,
          backgroundColor: isBuy ? 'rgba(240,83,89,0.4)' : 'rgba(22,177,87,0.4)',
        };

        const [orderPrice, dataPrice] = isBuy ? [order.price, action.data.price] : [action.data.price, order.price];
        if (new BigNumber(orderPrice).minus(dataPrice).isPositive()) {
          const preCumulate = _.get(mapOrderBooksLeft, [prePrice, 'cumulate'], 0);
          order.cumulate = new BigNumber(order.quantity).plus(new BigNumber(preCumulate)).toNumber();
          order.sum = new BigNumber(_.get(mapOrderBooksLeft[prePrice], 'sum', 0)).plus(order.total).toFixedAndTrim(8);
        }

        prePrice = order.price;
      });

      return {
        ...state,
        [`${fieldUpdate.toLowerCase()}OrderBooks`]: orderBooks,
        [`${fieldUpdateLeft.toLowerCase()}OrderBooks`]: orderBooksLeft,
        [`map${fieldUpdate}OrderBooks`]: _.keyBy(orderBooks, 'price'),
        [`map${fieldUpdateLeft}OrderBooks`]: _.keyBy(orderBooksLeft, 'price'),
        maxQuantity,
      };

    case consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_SELL:
      maxQuantity = 0;
      mapSellOrderBooks = state.mapSellOrderBooks;

      maxPrice = 0;
      minPrice = Number.MAX_SAFE_INTEGER;
      prePrice = 0;
      // re-calculate quantity, sum, cumulate

      _.forEach(action.data, (orderBook) => {
        minPrice = Math.min(minPrice, orderBook.price);
        maxPrice = Math.max(maxPrice, orderBook.price);

        if (orderBook.quantity === 0) {
          delete mapSellOrderBooks[orderBook.price];
        } else {
          mapSellOrderBooks[orderBook.price] = orderBook;
        }
      });

      sellOrderBooks = _.chain(mapSellOrderBooks).values().orderBy(['price'], 'asc').value();
      maxSellOrderBooks = _.maxBy(sellOrderBooks, 'quantity');
      maxQuantity = _.get(maxSellOrderBooks, 'quantity', 0);

      _.forEach(sellOrderBooks, (order) => {
        // add style
        order.key = order.price;
        order.style = {
          width: `${`${order.quantity / maxQuantity * 100}`.substr(0, 4)}%`,
          backgroundColor: 'rgba(240, 83, 89, 0.4)',
        };

        if (new BigNumber(order.price).minus(minPrice).isPositive()) {
          order.total = new BigNumber(order.price).times(order.quantity).toFixedAndTrim(8);
          const preCumulate = _.get(mapSellOrderBooks, [prePrice, 'cumulate'], 0);
          order.cumulate = new BigNumber(order.quantity).plus(new BigNumber(preCumulate)).toNumber();
          order.sum = new BigNumber(_.get(mapSellOrderBooks[prePrice], 'sum', 0)).plus(order.total).toFixedAndTrim(8);
        }

        prePrice = order.price;
      });

      return {
        ...state,
        sellOrderBooks,
        mapSellOrderBooks: _.keyBy(sellOrderBooks, 'price'),
        maxQuantity,
      };

    case consts.WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_BUY:
      maxQuantity = 0;
      mapBuyOrderBooks = state.mapBuyOrderBooks;

      maxPrice = 0;
      minPrice = Number.MAX_SAFE_INTEGER;
      prePrice = 0;
      // re-calculate quantity, sum, cumulate

      _.forEach(action.data, (orderBook) => {
        minPrice = Math.min(minPrice, orderBook.price);
        maxPrice = Math.max(maxPrice, orderBook.price);

        if (orderBook.quantity === 0) {
          delete mapBuyOrderBooks[orderBook.price];
        } else {
          mapBuyOrderBooks[orderBook.price] = orderBook;
        }
      });

      buyOrderBooks = _.chain(mapBuyOrderBooks).values().orderBy(['price'], 'desc').value();
      maxBuyOrderBooks = _.maxBy(buyOrderBooks, 'quantity');
      maxQuantity = _.get(maxBuyOrderBooks, 'quantity', 0);

      _.forEach(buyOrderBooks, (order) => {
        // add style
        order.key = order.price;
        order.style = {
          width: `${`${order.quantity / maxQuantity * 100}`.substr(0, 4)}%`,
          backgroundColor: 'rgba(22,177,87,0.4)',
        };

        if (new BigNumber(maxPrice).minus(order.price).isPositive()) {
          order.total = new BigNumber(order.price).times(order.quantity).toFixedAndTrim(8);
          const preCumulate = _.get(mapBuyOrderBooks, [prePrice, 'cumulate'], 0);
          order.cumulate = new BigNumber(order.quantity).plus(new BigNumber(preCumulate)).toNumber();
          order.sum = new BigNumber(_.get(mapBuyOrderBooks[prePrice], 'sum', 0)).plus(order.total).toFixedAndTrim(8);
        }

        prePrice = order.price;
      });

      return {
        ...state,
        buyOrderBooks,
        mapBuyOrderBooks: _.keyBy(buyOrderBooks, 'price'),
        maxQuantity,
      };

    case MAKE_ORDER_BOOK_EMPTY:
      return {
        ...state,
        orderBooks: [],
        sellOrderBooks: [],
        buyOrderBooks: [],
        mapBuyOrderBooks: {},
        mapSellOrderBooks: {},
        maxQuantity: 0,
      };
    default:
      return {
        ...state,
        isClickedOrderBookBuy: false,
        isClickedOrderBookSell: false,
      };
  }
};
